import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { FinancialStatementQ3Ruleset } from '../../business/ruleset';
import loanFormModel, { taxDocuments } from '../../form_models/loanFormModel';

const { applicantFiledTaxReturnsInThePast, financialStatementQ3 } =
  taxDocuments;

const { borrowerBusinessEstablishedYear } = loanFormModel.formField;

// uid: <BWR-FIN_STMT_YTD_Q3-FILE>
export class FinancialStatementQ3Validation implements ValidationSchema {
  public name = financialStatementQ3.name;
  public label = financialStatementQ3.getLabel(defaultApplicantName);
  public dependsOn: string[] = [
    borrowerBusinessEstablishedYear.name,
    applicantFiledTaxReturnsInThePast.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = FinancialStatementQ3Ruleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    return FileNameValidationSchema(financialStatementQ3.name, required);
  }
}
export default new Validation(new FinancialStatementQ3Validation());
